<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  
      <el-form :inline="true" class="backborder1s demo-form-inline" ref="query" :model="query" size="small">
          <el-form-item style="width:19%">
		          <el-date-picker
		              v-model="query.date"
		              type="daterange"
		              range-separator="至"
		              start-placeholder="开始日期"
		              end-placeholder="结束日期"
                  :unlink-panels="false"
		              value-format="yyyy-MM-dd" @change="isselect=true" clearable style="width:100%">
		          </el-date-picker>
	        </el-form-item>
          <!-- 关键字 -->
          <el-form-item>
              <el-input placeholder="请输入商品名称 / 商品规格" v-model="query.key" @keyup.enter.native="getList" clearable></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" circle @click="getList"></el-button>
          </el-form-item>
      </el-form>

      <!-- 活动信息小计 -->
      <div class="backborder2" style="margin-top:10px;padding:3px 1% 30px 1%;background:none;border:none">
        <div style="float:left;width:100%">
            <el-tooltip class="item" effect="dark" content="包含特价商品的商城订单数量小计（已付款的订单）" placement="top">
                <span class="activetotal">下单次数小计：{{stattotals.orders}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="商城下单包含特价商品的店铺数量小计（已付款的订单）" placement="top">
                <span class="activetotal">下单店铺数小计：{{stattotals.shops}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="商城下单包含特价商品的人数小计（已付款的订单）" placement="top">
                <span class="activetotal">下单人数小计：{{stattotals.users}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="特价商品在商城所下的订单里实际付款的金额小计（已付款的订单）" placement="top">
                <span class="activetotal">实付金额小计：{{stattotals.totals}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="特价商品在商城所下的订单里的成本小计（已付款的订单）" placement="top">
                <span class="activetotal">成本小计：{{stattotals.costs}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="特卖商品在商城所下的订单里的商品总数（已付款的订单）" placement="top">
                <span class="activetotal">下单商品种数小计：{{stattotals.goodsnums}}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="特卖商品在商城所下的订单里的商品规格总数（已付款的订单）" placement="top">
                <span class="activetotal">下单商品规格种数小计：{{stattotals.specsnums}}</span>
            </el-tooltip>
        </div>
      </div>

      <!----  活动商品信息统计 --------->
      <div class="backborder2 backbbtn" style="margin-top:10px">
	      <el-table :data="datalists" v-loading="listLoading">
	          <el-table-column label="商品信息">
              <template slot-scope="scope">
                <div class="specialgoods">
                   <div class="thumb"><img :src="scope.row.thumb" /></div>
                   <div class="content">
                       <span class="name">{{scope.row.productname}}</span>
                       <span class="spec">规格：{{scope.row.propertyname}}</span>
                   </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="allnums" label="销售数量" width="100" align="center"></el-table-column>
            <el-table-column prop="orders" label="订单数量" width="100" align="center"></el-table-column>
            <el-table-column prop="shops" label="下单店铺数" width="100" align="center"></el-table-column>
            <el-table-column prop="users" label="下单人数" width="100" align="center"></el-table-column>  
            <el-table-column prop="totals" label="实付金额" width="100" align="center"></el-table-column>
            <el-table-column prop="costs" label="成本" width="100" align="center"></el-table-column>
            <el-table-column label="操作" width="90" align="center">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="商品下单统计" placement="top">
                      <el-button type="warning" icon="el-icon-goods" size="mini" circle @click="getorderstats(scope.row)"></el-button>
                  </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
		      <!--分页begin-->
		      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="total_rows">
		      </el-pagination>
		      <!--分页end-->
	      </div>
    </div>

    <!-- 活动商品信息订单详情 -->
    <el-dialog title="订单信息详情" :visible.sync="goodsorderDialog" width="95%" top="10vh">
       <el-table :data="goodsorderlists" v-loading="goodsorderloading">
	          <el-table-column label="订单信息">
              <template slot-scope="scope">
                <div class="showoffersgoods">{{scope.row.sn}}</div>
                <div class="showoffersgoodsspec">下单店铺：{{scope.row.shopname}}</div>
                <div class="showoffersgoodsspec">下单城市：{{scope.row.city}}</div>
                <div class="showoffersgoodsspec">详细地址：{{scope.row.address}}</div>
              </template>
            </el-table-column>
            <el-table-column label="收货人" prop="truename" width="100" align="center"></el-table-column>
            <el-table-column label="收货电话" prop="phone" width="120" align="center"></el-table-column>
            <el-table-column label="单价" prop="price" width="100" align="center"></el-table-column>
            <el-table-column label="数量" prop="numbers" width="100" align="center"></el-table-column>
            <el-table-column label="实付小计" prop="totals" width="100" align="center"></el-table-column>
            <el-table-column label="成本" prop="costs" width="100" align="center"></el-table-column>
            <el-table-column label="付款时间" prop="pay_time" width="150" align="center"></el-table-column>
            <el-table-column label="发货单号" prop="sendsn" width="130" align="center"></el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageoffersordersChange"
            @current-change="pageoffersordersCurrentChange"
            :current-page="orderquery.p"
            :page-sizes="[10, 20, 50]"
            :page-size="orderquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="orders_row">
          </el-pagination>
          <!--分页end-->
        </div>
    </el-dialog>
    <!-- 活动商品信息订单详情 -->

  </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
        url:this.GLOBAL.domain+"Offers/index",
        transitionshow:true,
        actionauth:'', //功能权限
        isselect:false,
        listLoading:false,
        query: {
          act:'getoffersspeciallists2',
	        token:this.$cookies.get('token'),
          date:[new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate(),new Date().getFullYear().toString()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate()],
          //date:[],
          key:'',
          p:1,
          rollpage:10
        },
        datalists:[],
        total_rows:0,
        stattotals: {
          orders:0,
          shops:0,
          users:0,
          totals:0,
          costs:0,
          goodsnums:0,
          specsnums:0,
        },
        orderquery:{
          act:'getofferspecialorderstat2',
          token:this.$cookies.get('token'),
          date:[],
          propertyid:'',
          p:1,
          rollpage:10
        },
        goodsorderlists:[],
        goodsorderDialog:false,
        goodsorderloading:false,
        orders_row:0,

    }
  },
  
  mounted(){
    this.getactionauth();
    this.getList();
  },
  
  methods:{
  
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },

    /** 获取信息统计 **/
    getList() {
        if(this.isselect) {
            this.query.p=1;
            this.query.rollpage=10;
        }
        this.listLoading=true;
        var resource = this.$resource(this.url);
	      resource.save(this.query).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
            this.listLoading = false;
		    }else{
		        this.datalists = JSON.parse(Base64.decode(res.data.Data));
            this.total_rows=parseInt(res.data.count);
            this.listLoading = false;
            if(this.isselect) this.isselect=false;
            this.getstattotals();
		    }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
            this.listLoading = false;
	      });
    },

    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },


    /** 统计商品小计信息 **/
    getstattotals() {
        this.stattotals.orders=0;
        this.stattotals.shops=0;
        this.stattotals.users=0;
        this.stattotals.totals=0;
        this.stattotals.costs=0;
        this.stattotals.goodsnums=0;
        this.stattotals.specsnums=0;
        let statquery={
            act:'getoffersspecialstats2',
            token:this.query.token,
            date:this.query.date,
            key:this.query.key
        };
        var resource = this.$resource(this.url);
        resource.save(statquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
                this.stattotals.orders=result.orders;
                this.stattotals.shops=result.shops;
                this.stattotals.users=result.users;
                this.stattotals.totals=result.totals;
                this.stattotals.costs=result.costs;
                this.stattotals.goodsnums=result.goodsnums;
                this.stattotals.specsnums=result.specsnums;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },


    getorderstats(obj) {
      this.orderquery.date=this.query.date;
      this.orderquery.propertyid=obj.propertyid;
      this.orderquery.p=1;
      this.orderquery.rollpage=10;
      this.goodsorderDialog=true;
      this.getorderlists();
    },


    //获取当前商品的下单信息
    getorderlists() {
        this.goodsorderloading=true;
        var resource = this.$resource(this.url);
        resource.save(this.orderquery).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.goodsorderloading=false;
            }else{
                this.goodsorderlists = JSON.parse(Base64.decode(res.data.Data));
                this.orders_row=parseInt(res.data.count);
                this.goodsorderloading=false;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.goodsorderloading=false;
        });
    },

    pageoffersordersChange(val) {
        this.orderquery.rollpage = val;
        this.getorderlists();
    },
    pageoffersordersCurrentChange(val) {
        this.orderquery.p = val;
        this.getorderlists();
    },





     
  }
}
</script>
<style>
.backborder1s {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder2s {background:rgba(211, 211, 211, 0.6);border-radius:5px;border:1px solid #ddd;min-height:70px;overflow:hidden;transition:.36s all}
.backborder2s .content {float:left;width:95%;font-size:12px;}
.backborder2s .content ul {margin:0;padding:0}
.backborder2s .content li {float:left;width:100%;list-style-type:none;line-height:18px;color:red;margin-top:5px}
.backborder2s .close {float:right;width:5%}
.backborder2s .close .el-button--mini.is-circle {padding:5px;margin-top:50px}
.closenotice {display:none}
.backbbtn .el-button--mini.is-circle {margin:0}

.specialgoods {float:left;width:100%}
.specialgoods .thumb {float:left;width:11%;border-radius:5px;padding:2px;border:1px solid #dddddd}
.specialgoods .thumb img {float:left;width:100%}
.specialgoods .content {float:left;width:80%;margin-left:5px}
.specialgoods .content .name {float:left;width:100%;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.specialgoods .content .spec {font-size:12px;color:#999999;float:left;width:100%;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.activetotal {float:left;margin-right:3%;color:#8b572a;font-size:13px;font-weight:550}
</style>


// WEBPACK FOOTER //
// src/components/mall/Offersspecial2.vue